function NeedsIntlPolyfill(method) {
  return typeof globalThis.Intl?.[method] !== "function";
}

/**
 * Dynamically imports polyfills for Intl methods if they are not supported
 * in the current environment.
 */
export async function initialize() {
  if (NeedsIntlPolyfill("getCanonicalLocales"))
    await import("@formatjs/intl-getcanonicallocales/polyfill.js");

  if (NeedsIntlPolyfill("Locale"))
    await import("@formatjs/intl-locale/polyfill.js");

  if (NeedsIntlPolyfill("PluralRules"))
    await import("@formatjs/intl-pluralrules/polyfill.js");

  if (NeedsIntlPolyfill("NumberFormat"))
    await import("@formatjs/intl-numberformat/polyfill.js");

  if (NeedsIntlPolyfill("RelativeTimeFormat"))
    await import("@formatjs/intl-relativetimeformat/polyfill.js");

  if (NeedsIntlPolyfill("DateTimeFormat"))
    await import("@formatjs/intl-datetimeformat/polyfill.js");

  if (typeof Array.prototype.at !== "function") {
    const at = await import("array.prototype.at");
    at.shim();
  }
}

export default {
  initialize
};
